import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreStore } from '../../../core/state/core.store';
import { joinApiUrl } from '../../../core/config/api-url';
import { ILoginModel } from '../../models/login';
import { ILoginPayload } from '../../interfaces/login-payload';
import { IResetPasswordPayload } from '../../interfaces/reset-password';

@Injectable({
  providedIn: 'root',
})
export class AuthLogin {
  private readonly _http = inject(HttpClient);
  private readonly _store = inject(CoreStore);

  login(body: ILoginPayload): Observable<ILoginModel> {
    return this._http.post<ILoginModel>(this._url(this._store.endpoints().auth.login), body);
  }

  logout(): Observable<void> {
    return this._http.post<void>(this._url(this._store.endpoints().auth.logout), null);
  }

  resetPassword(username: IResetPasswordPayload): Observable<void> {
    return this._http.post<void>(this._url(this._store.endpoints().auth.resetPassword), username);
  }

  private _url(path: string): string {
    return joinApiUrl(this._store.userManagementBaseUrl(), path);
  }
}
